// extracted by mini-css-extract-plugin
module.exports = {"quote":"QuoteSection_quote__ItPbN","quoteContainer":"QuoteSection_quoteContainer__ZYHsE","author":"QuoteSection_author__phiiD"};